<template>
    <div class="app">
        <div
            class="bg"
            :class="{ loaded: !loading }"
            :style="{ 'background-image': 'url(' + bgUrl + ')' }"
        ></div>
        <transition name="fade" mode="out-in" @afterEnter="afterEnter">
            <div
                v-if="triggerLoadingSpinner && loading"
                class="loading"
                key="loading"
                :duration="triggerLoadingSpinner ? 4000 : 100"
            >
                <div class="spinner"></div>
            </div>
            <div v-else-if="!loading" key="content">
                <div class="main">
                    <h2 class="header" :class="{ 'intro-fade-in': socialsAnimating }">
                        <span
                            v-for="(letter, index) in $options.title"
                            :key="'letter-' + index"
                            :class="{
                                hidden: !letterVisibility[index],
                                'fade-in': letterTransitioning[index],
                            }"
                            >{{ letter }}</span
                        >
                    </h2>
                    <div class="socials" :class="{ 'intro-fade-in': socialsAnimating }">
                        <a
                            key="sc"
                            class="social sc"
                            :class="{
                                hidden: !iconVisibility[0],
                                'fade-in': iconTransitioning[0],
                                'no-pointer': socialsAnimating,
                            }"
                            href="https://soundcloud.com/sporradik"
                            target="_blank"
                        >
                            <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                viewBox="0 0 512 512"
                                style="enable-background: new 0 0 512 512"
                                xml:space="preserve"
                            >
                                <path
                                    d="M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M83.3,311.8c0,0.8-0.6,1.4-1.4,1.4
                        c-0.8,0-1.4-0.6-1.4-1.4l-2.6-19.5l2.6-19.8c0-0.8,0.7-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l3.1,19.8L83.3,311.8z M96.6,323.7
                        c-0.1,0.8-0.7,1.4-1.5,1.4c-0.8,0-1.4-0.7-1.5-1.4l-3.5-31.3l3.5-32c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5l4,32L96.6,323.7z
                         M110.8,329c0,1-0.8,1.7-1.8,1.7c-1,0-1.8-0.8-1.8-1.7l-3.3-36.6l3.3-38c0-1,0.8-1.8,1.8-1.8c1,0,1.7,0.8,1.8,1.8l3.8,38L110.8,329z
                         M125.3,330.1c-0.1,1.1-1,2-2.1,2c-1.1,0-2.1-0.9-2.1-2l-3.1-37.7l3.1-39c0-1.1,1-2,2.1-2.1c1.1,0,2,0.9,2.1,2.1l3.6,39L125.3,330.1
                        z M139.8,330.4c0,1.3-1.1,2.4-2.4,2.3c-1.3,0-2.3-1.1-2.3-2.3l-3-38l3-36.2c0-1.3,1.1-2.4,2.4-2.3c1.3,0,2.3,1,2.3,2.3l3.4,36.2
                        L139.8,330.4z M154.4,330.4L154.4,330.4c0,1.5-1.3,2.7-2.7,2.6c-1.5,0-2.6-1.2-2.7-2.6l-2.8-38l2.8-58.9c0-1.5,1.3-2.7,2.7-2.7
                        c1.5,0,2.6,1.2,2.7,2.6l3.1,58.9L154.4,330.4z M169,330.4L169,330.4c0,1.6-1.3,3-3,3c-1.7,0-3-1.3-3-3l-2.6-37.8l2.6-72.3
                        c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3l2.9,72.3L169,330.4z M184.1,329.8L184.1,329.8c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3l0,0
                        l-2.4-37.4c0,0,2.4-78.4,2.4-78.4c0-1.8,1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3l0,0l2.7,78.4L184.1,329.8z M199.1,329.6
                        c0,2-1.7,3.6-3.7,3.6c-1.9,0-3.5-1.6-3.6-3.5l-2.3-37.2l2.3-81c0-2,1.7-3.6,3.7-3.5c1.9,0,3.5,1.6,3.5,3.5l2.5,81L199.1,329.6z
                         M214.2,329.2L214.2,329.2c0,2.1-1.8,3.9-3.9,3.9c-2.1,0-3.9-1.7-3.9-3.9l-2.1-36.8l2.1-78.9c0-2.2,1.8-3.9,3.9-3.9
                        c2.2,0,3.9,1.8,3.9,3.9l0,0l2.3,78.9L214.2,329.2z M229.4,329L229.4,329c0,2.3-1.9,4.2-4.3,4.1c-2.3,0-4.1-1.9-4.2-4.1l-1.9-36.6
                        l1.9-76.1c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2l2.1,76.1L229.4,329z M244.9,325.2l-0.2,3.6c0,1.2-0.5,2.3-1.4,3.2
                        c-0.8,0.8-2,1.3-3.2,1.3c-2.4,0-4.4-1.9-4.5-4.3c0-0.1,0-0.1,0-0.2c0,0-1.7-36.3-1.7-36.4l1.7-89.6l0-0.9c0-1.5,0.8-2.9,2.1-3.8
                        c1.5-1,3.4-1,4.9,0c1.3,0.8,2,2.2,2,3.7l1.9,90.5L244.9,325.2z M260,328.3L260,328.3c-0.1,2.6-2.3,4.7-4.9,4.7
                        c-2.6-0.1-4.7-2.1-4.7-4.7l-1-17.7l-1-18.1l2-98.2v-0.5c0-1.4,0.7-2.8,1.8-3.7c1.6-1.3,3.8-1.5,5.5-0.4c1.4,0.9,2.3,2.4,2.4,4.1
                        l2.1,98.7 M390.3,333.1H268.9c-2.6-0.2-4.7-2.4-4.7-5V189c0-2.6,0.9-3.9,4.2-5.1c8.9-3.5,18.5-5.2,28-5.2c40,0,73.4,30.6,77,70.5
                        c22.3-9.4,47.9,1,57.3,23.3c9.4,22.3-1,47.9-23.3,57.3C402,332,396.2,333.2,390.3,333.1L390.3,333.1z"
                                />
                            </svg>
                        </a>
                        <a
                            key="ig"
                            class="social ig"
                            :class="{
                                hidden: !iconVisibility[1],
                                'fade-in': iconTransitioning[1],
                                'no-pointer': socialsAnimating,
                            }"
                            href="https://instagram.com/_sprdk"
                            target="_blank"
                        >
                            <svg
                                fill="#000000"
                                height="800px"
                                width="800px"
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                viewBox="-143 145 512 512"
                                xml:space="preserve"
                            >
                                <g>
                                    <path
                                        d="M113,446c24.8,0,45.1-20.2,45.1-45.1c0-9.8-3.2-18.9-8.5-26.3c-8.2-11.3-21.5-18.8-36.5-18.8s-28.3,7.4-36.5,18.8
c-5.3,7.4-8.5,16.5-8.5,26.3C68,425.8,88.2,446,113,446z"
                                    />
                                    <polygon
                                        points="211.4,345.9 211.4,308.1 211.4,302.5 205.8,302.5 168,302.6 168.2,346 	"
                                    />
                                    <path
                                        d="M183,401c0,38.6-31.4,70-70,70c-38.6,0-70-31.4-70-70c0-9.3,1.9-18.2,5.2-26.3H10v104.8C10,493,21,504,34.5,504h157
		c13.5,0,24.5-11,24.5-24.5V374.7h-38.2C181.2,382.8,183,391.7,183,401z"
                                    />
                                    <path
                                        d="M113,145c-141.4,0-256,114.6-256,256s114.6,256,256,256s256-114.6,256-256S254.4,145,113,145z M241,374.7v104.8
		c0,27.3-22.2,49.5-49.5,49.5h-157C7.2,529-15,506.8-15,479.5V374.7v-52.3c0-27.3,22.2-49.5,49.5-49.5h157
		c27.3,0,49.5,22.2,49.5,49.5V374.7z"
                                    />
                                </g>
                            </svg>
                        </a>
                        <a
                            key="fb"
                            class="social fb"
                            :class="{
                                hidden: !iconVisibility[2],
                                'fade-in': iconTransitioning[2],
                                'no-pointer': socialsAnimating,
                            }"
                            href="https://facebook.com/sporradik"
                            target="_blank"
                        >
                            <svg
                                version="1.1"
                                id="Capa_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                viewBox="0 0 512 512"
                                style="enable-background: new 0 0 512 512"
                                xml:space="preserve"
                            >
                                <path
                                    d="M512,256C512,114.6,397.4,0,256,0S0,114.6,0,256s114.6,256,256,256c1.5,0,3,0,4.5-0.1V312.7h-55v-64.1h55v-47.2
                    c0-54.7,33.4-84.5,82.2-84.5c23.4,0,43.5,1.7,49.3,2.5v57.2h-33.6c-26.5,0-31.7,12.6-31.7,31.1v40.8h63.5l-8.3,64.1h-55.2v189.5
                    C433.7,471.4,512,372.9,512,256z"
                                />
                            </svg>
                        </a>
                        <a
                            key="em"
                            class="social em"
                            :class="{
                                hidden: !iconVisibility[3],
                                'fade-in': iconTransitioning[3],
                                'no-pointer': socialsAnimating,
                            }"
                            href="mailto:sporradiksounds@gmail.com"
                            target="_blank"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                            >
                                <title>email</title>
                                <path
                                    d="M256,0C114.62,0,0,114.62,0,256S114.62,512,256,512,512,397.38,512,256,397.38,0,256,0ZM114.59,144.9H397.41A20,20,0,0,1,417,162.09L256,268.16,95,162.09A20,20,0,0,1,114.59,144.9Zm-20.2,41,109,71.8-109,68.88Zm303,181.24H114.59A19.92,19.92,0,0,1,95,350.05l126.82-80.21,28.58,18.84a10.14,10.14,0,0,0,11.12,0l28.58-18.82L417,350.05A19.92,19.92,0,0,1,397.41,367.1Zm20.2-40.56-109-68.88,109-71.8Z"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import bgUrl from "./assets/wood2.jpg";

export default {
    name: "App",
    title: "sprdk",
    data() {
        return {
            bgUrl,
            triggerLoadingSpinner: false,
            loading: true,
            letterVisibility: [false, false, false, false, false],
            iconVisibility: [false, false, false, false],
            letterTransitioning: [false, false, false, false, false],
            iconTransitioning: [false, false, false, false],
            socialsAnimating: true,
        };
    },
    created() {
        const bg = new Image();
        bg.src = bgUrl;
        if (bg.complete) this.onLoad();
        else {
            bg.addEventListener("load", this.onLoad);
            setTimeout(() => {
                if (!bg.complete) this.triggerLoadingSpinner = true;
            }, 200);
        }
    },
    mounted() {
        // Handle hot reload - if already loaded, show everything
        if (!this.loading) {
            this.letterVisibility = [true, true, true, true, true];
            this.iconVisibility = [true, true, true, true];
            this.socialsAnimating = false;
            this.startFlicker();
        }
    },
    methods: {
        onLoad() {
            this.loading = false;
        },
        afterEnter() {
            let letterDelay = 100;
            let letterIndex = 0;
            const showNextLetter = () => {
                if (letterIndex < this.letterVisibility.length) {
                    this.$set(this.letterTransitioning, letterIndex, true);
                    this.$set(this.letterVisibility, letterIndex, true);
                    letterIndex++;
                    letterDelay += 10;
                    setTimeout(showNextLetter, letterDelay);
                }
            };
            setTimeout(showNextLetter, letterDelay);

            setTimeout(() => {
                let iconDelay = 100;
                let iconIndex = 0;
                const showNextIcon = () => {
                    if (iconIndex < this.iconVisibility.length) {
                        this.$set(this.iconTransitioning, iconIndex, true);
                        this.$set(this.iconVisibility, iconIndex, true);
                        iconIndex++;
                        iconDelay += 100;
                        setTimeout(showNextIcon, iconDelay);
                    } else {
                        // Initial animation complete, re-enable pointer events and start flicker
                        this.socialsAnimating = false;
                        setTimeout(this.startFlicker, 2000);
                    }
                };
                setTimeout(showNextIcon, iconDelay);
            }, 1200);
        },
        startFlicker() {
            const flickerElement = () => {
                // Randomly choose between letters and icons
                const useLetters = Math.random() < 0.5;
                const visibilityArray = useLetters
                    ? this.letterVisibility
                    : this.iconVisibility;
                const transitioningArray = useLetters
                    ? this.letterTransitioning
                    : this.iconTransitioning;

                // Pick random index
                const randomIndex = Math.floor(
                    Math.random() * visibilityArray.length
                );

                // Hide element instantly (no transition)
                this.$set(transitioningArray, randomIndex, false);
                this.$set(visibilityArray, randomIndex, false);

                // Show it again with fade-in transition
                setTimeout(() => {
                    this.$set(transitioningArray, randomIndex, true);
                    this.$set(visibilityArray, randomIndex, true);
                }, 75);

                // Schedule next flicker with random delay (500-3000ms)
                const nextDelay = 50 + Math.random() * 5000;
                setTimeout(flickerElement, nextDelay);
            };

            flickerElement();
        },
    },
};
</script>

<style>
@font-face {
    font-family: "Himagsikan";
    src: url("assets/Himagsikan-MoXB.ttf") format("truetype"),
        url("assets/himagsikan-moxb-webfont.eot") format("embedded-opentype"),
        url("assets/himagsikan-moxb-webfont.woff") format("woff"),
        url("assets/himagsikan-moxb-webfont.svg") format("svg");
}

:root {
    --icon-size: 75px;
    --icon-padding: 25px;
    --font-size: 140px;
    font-family: "Himagsikan", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: white;
}

.app {
    height: 100%;
    width: 100%;
    text-align: center;
}

.hidden {
    opacity: 0;
}

.fade-in {
    transition: opacity 0.05s ease;
}

.intro-fade-in .fade-in {
  transition: opacity 0.2s ease; /* slower for intro */
}

.intro-fade-in .fade-in.social {
  transition: opacity 0.7s ease; /* slower for intro */
}


.no-pointer {
    pointer-events: none;
}

.spinner {
    height: 50px;
    width: 50px;
    background-color: #fff;
    animation: spin 750ms ease infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(90deg);
    }
}

.bg {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
    background-image: var(--background-image);
    background-position: center center;
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-size: cover;
    filter: brightness(0.5);
    transition: opacity 1s ease;
}
.bg.loaded {
    opacity: 1;
}

.main,
.loading {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
h2 {
    position: relative;
    margin: 10px 0;
    cursor: default;
}

h2 span {
    user-select: none;
    font-size: var(--font-size);
    display: inline-block;
    transition: transform 0.5s ease;
    transform: perspective(100px);
    -webkit-tap-highlight-color: transparent;
}

h2 div {
    position: absolute;
}

h2 .hidden {
    visibility: hidden;
}

h2 span:hover {
    transform: perspective(100px) translateZ(10px);
}

.socials {
    min-width: calc(var(--icon-size) * 3 + var(--icon-padding) * 6);
    min-height: calc((var(--icon-size) + var(--icon-padding) * 2) + 5px);
    display: inline-flex;
    align-items: center;
}

.social {
    padding: var(--icon-padding);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

.social svg {
    height: var(--icon-size);
    width: var(--icon-size);
    fill: white;
    transition: transform 0.5s ease;
    transform: perspective(100px);
}

.social:hover svg {
    transform: perspective(100px) translateZ(10px);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s ease;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

@media handheld and (max-width: 740px),
    screen and (max-device-width: 740px),
    screen and (max-width: 740px) {
    :root {
        --font-size: 100px;
        --icon-size: 60px;
        --icon-padding: 15px;
    }
}
</style>
